// Minimal dataLayer helper for GTM (container GTM-K4WKF75L, loaded from
// public/index.html). Pushing before the container loads is harmless — the
// array just accumulates. All jobs-app analytics (GA4 G-HBR82YG9EZ, HubSpot,
// Google Ads AW-1019972986) live inside that one container.
export function gtmPush(data: Record<string, unknown>): void {
  const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(data);
}
